export const FAHRENHEIT = "Fahrenheit";
export const CELSIUS = "Celsius";